export const Props = () => ({
  //----------------------------------------------------------------------------
  //          Применять ли к блоку с описнаием кэпитала адаптивный формат
  //----------------------------------------------------------------------------
  descriptionAdaptive: {
    type: Boolean,
    required: false,
    default: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});